import { render, staticRenderFns } from "./ModalMangaNewsPlanning.vue?vue&type=template&id=773033fe&scoped=true"
import script from "./ModalMangaNewsPlanning.ts?vue&type=script&lang=ts&external"
export * from "./ModalMangaNewsPlanning.ts?vue&type=script&lang=ts&external"
import style0 from "./ModalMangaNewsPlanning.vue?vue&type=style&index=0&id=773033fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773033fe",
  null
  
)

export default component.exports